import { Spinner } from "@/components/util";
import { useButton, type UseButtonProps } from "./use-button";

export type ButtonProps = UseButtonProps;

export const Button = (props: ButtonProps) => {
  const {
    styles,
    className,
    Component,
    loadingLabel,
    isLoading,
    children,
    ...rest
  } = useButton(props);

  return (
    <Component className={styles.base({ className })} {...rest}>
      {isLoading ? (
        <>
          <Spinner className={styles.loading()} /> {loadingLabel}
        </>
      ) : (
        children
      )}
    </Component>
  );
};
